import { combineReducers } from 'redux';
import { postingFlowSlice } from 'Douleutaras/redux/data/pros/postingFlowSlice';

export default combineReducers({
  postingFlow: postingFlowSlice.reducer
});
